import { render, staticRenderFns } from "./FiltersModal.vue?vue&type=template&id=38b12d54"
import script from "./FiltersModal.vue?vue&type=script&lang=ts"
export * from "./FiltersModal.vue?vue&type=script&lang=ts"
import style0 from "./FiltersModal.vue?vue&type=style&index=0&id=38b12d54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports